import { labelFor } from '../../constants/personal-survey-fields';

export const formatFieldValue = (field, value) => {
  if (value == null || value === '') return '-';

  if (field.type === 'select') return labelFor(field.options, value);

  if (field.type === 'multiselect') {
    if (!Array.isArray(value) || value.length === 0) return '-';
    return value.map((v) => labelFor(field.options, v)).join(', ');
  }

  if (field.type === 'boolean') return value ? 'Da' : 'Ne';

  if (field.type === 'rating') return `${value} / ${field.max ?? 5}`;

  if (field.type === 'repeatable') {
    if (!Array.isArray(value) || value.length === 0) return '-';
    return value
      .map((item) =>
        field.itemFields
          .map((itemField) => formatFieldValue(itemField, item[itemField.key]))
          .join(' - ')
      )
      .join('; ');
  }

  return String(value);
};

export const buildReadRows = (fieldConfig, sectionData) => {
  const values = sectionData || {};
  return fieldConfig
    .filter((field) => (field.visibleIf ? field.visibleIf(values) : true))
    .map((field) => ({
      info: field.label,
      value: formatFieldValue(field, values[field.key]),
    }));
};
